import { AbstractControl } from "@angular/forms";

const CPF_VALID_LENGTH = 11;
const NON_DIGIT_REGEX = /[^\d]/g;
const SAME_DIGIT_REGEX = /^(\d)\1*$/;

export function cpfValidator(control: AbstractControl): { invalidCPF: boolean } | null {
	const cpf = control.value;

	if (!cpf) {
		return null; // If no value is provided, don't perform validation
	}

	// CPF validation logic goes here
	if (!isValidCPF(cpf)) {
		return { invalidCPF: true };
	}

	return null; // Valid CPF
}

function isValidCPF(cpf: string): boolean {
	cpf = cpf.replace(NON_DIGIT_REGEX, "");

	// Check cpf length
	if (cpf.length !== CPF_VALID_LENGTH) {
		return false;
	}

	// Check if all digits are the same
	if (SAME_DIGIT_REGEX.test(cpf)) {
		return false; // All digits are the same
	}

	const cpfArray = cpf.split("").map(Number);

	// Check the First Verifier Digit
	const sum = cpfArray.slice(0, 9).reduce((acc, value, index) => acc + value * (10 - index), 0);
	const remainder = (sum * 10) % 11;

	if (remainder === 10 || remainder === 11) {
		if (cpfArray[9] !== 0) {
			return false;
		}
	} else if (cpfArray[9] !== remainder) {
		return false;
	}

	// Check the Second Verifier Digit
	const sum2 = cpfArray.slice(0, 10).reduce((acc, value, index) => acc + value * (11 - index), 0);
	const remainder2 = (sum2 * 10) % 11;

	if (remainder2 === 10 || remainder2 === 11) {
		if (cpfArray[10] !== 0) {
			return false;
		}
	} else if (cpfArray[10] !== remainder2) {
		return false;
	}

	return true;
}
